/* Datos de usuarios */
export const myAccount = '/configuracion';
export const userData = `${myAccount}/datos`;
export const userPassword = `${myAccount}/password`;
export const userEmail = `${myAccount}/email`;
export const userNotifications = `${myAccount}/correo`;
export const userDelete = `${myAccount}/eliminar`;

/* Mi actividad */
export const myActivity = '/actividad';
export const favorites = `${myActivity}/favoritos`;
export const viewed = `${myActivity}/vistos`;
export const discarded = `${myActivity}/ocultos`;
export const savedSearches = `${myActivity}/busquedas-guardadas`;

/* Empresa */
export const myCompany = '/empresa';
export const companyData = `${myCompany}/datos`;
export const companyBranch = `${myCompany}/sucursales`;
export const companyUsers = `${myCompany}/usuarios`;
export const companyConfiguration = `${myCompany}/configuracion`;
export const companyMicrosite = `${myCompany}/micrositio`;
export const companyShareCommission = `${myCompany}/compartir-comision`;
